import MetricVisualization from './MetricVisualization';
import './MetricVisualization.scss';

export { schema, uiSchema } from '../schemas/MetricVisualizationSchema';
export default MetricVisualization;
